import script from "./ImageTextComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageTextComponent.vue?vue&type=script&setup=true&lang=js"

import "./ImageTextComponent.vue?vue&type=style&index=0&id=1a34e03e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a34e03e"]])

export default __exports__